import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import { parseISO } from "date-fns";
import PropTypes from "prop-types";
// utils
import { isEmpty } from "../../../../../services/general.utils";
import {
  formatToStartOfDay,
  startFutureMonthFromDate
} from "../../../../../services/date.utils";
import { useTranslation } from "react-i18next";

const DateInput = ({ values, setFieldValue, isNotCompanyBonusBudget }) => {
  const { t } = useTranslation();

  const now = new Date();
  const isLocked =
    isNotCompanyBonusBudget && now.getDate() > 25;

  const handleStartDateChange = selectedDate => {
    if (!selectedDate || isNaN(selectedDate) || isEmpty(selectedDate)) {
      return;
    }

    let date = new Date(selectedDate);

    date.setHours((-1 * date.getTimezoneOffset()) / 60);
    setFieldValue("startDate", formatToStartOfDay(date));
  };

  const handleEndDateChange = selectedDate => {
    if (!selectedDate || isNaN(selectedDate) || isEmpty(selectedDate)) {
      return;
    }
    if (selectedDate) {
      selectedDate.setHours((-1 * selectedDate.getTimezoneOffset()) / 60);
    }
    setFieldValue("endDate", formatToStartOfDay(selectedDate));
  };

  useEffect(() => {
    if (isNotCompanyBonusBudget && !isLocked) {
      setFieldValue("startDate", new Date());
      setFieldValue("endDate", startFutureMonthFromDate(new Date()));
    }
  }, [isNotCompanyBonusBudget, isLocked]);

  return (
    <>
      <div className="datepickerWrapper">
        <div className="labelAndValidation">
          <p className="label">{t("Bonus Start Date")}:</p>
        </div>

        <DatePicker
          className="datePickerInput"
          name="startDate"
          id="datePicker"
          selected={values.startDate}
          dateFormat="dd/MM/yyyy"
          onChange={handleStartDateChange}
          minDate={new Date()}
          disabled={isLocked}
          value={parseISO(values.startDate)}
          showYearDropdown
          placeholderText="DD/MM/YYYY"
        />

        {isLocked && (
          <p className="errorMessage">
            {t("bonus_budget_locked_after_25th")}
          </p>
        )}
      </div>

      <div className="datepickerWrapper">
        <div className="labelAndValidation">
          <p className="label">{t("Bonus End Date")}:</p>
        </div>

        <DatePicker
          className="datePickerInput"
          name="endDate"
          id="datePicker"
          selected={values.endDate}
          dateFormat="dd/MM/yyyy"
          onChange={handleEndDateChange}
          minDate={values.startDate ? new Date(new Date(values.startDate).setDate(new Date(values.startDate).getDate() + 1)) : new Date()}
          value={parseISO(values.endDate)}
          showYearDropdown
          placeholderText="DD/MM/YYYY"
        />
      </div>
    </>
  );
};

DateInput.propTypes = {
  values: PropTypes.shape(),
  setFieldValue: PropTypes.func,
  isNotCompanyBonusBudget: PropTypes.bool
};

export default DateInput;
